import React from "react";

function Button({ text, btnLg, type, handleClick, children }) {
  return (
    <button
      onClick={handleClick}
      type={type}
      className={`bg-blue-600 hover:bg-blue-700 text-white font-medium tracking-wide flex gap-2 items-center justify-center ${
        btnLg ? "p-4 rounded-xl" : "px-6 py-2 rounded-lg "
      }`}
    >
      {text}
      {children}
    </button>
  );
}

export default Button;
